import { useEffect, useState, useCallback } from "react";
import { Plus, Crown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { PlanFormDialog } from "@/components/admin/PlanFormDialog";
import { adminApi, brl, MODULE_LABELS, limitText } from "@/lib/api";
import { startingPrice } from "@/lib/modules";

export function PlansTab() {
  const [data, setData] = useState({ plans: [], modules: [] });
  const [form, setForm] = useState({ open: false, plan: null });
  const load = useCallback(() => adminApi.get("/plans").then((r) => setData(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <p className="text-sm text-muted-foreground">Os preços valem para novas contratações. Pagamentos pelo Stripe usam o valor atual do plano.</p>
        <Button onClick={() => setForm({ open: true, plan: null })} data-testid="admin-new-plan-btn"><Plus className="h-4 w-4 mr-1" />Novo plano</Button>
      </div>
      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-4">
        {data.plans.map((p) => (
          <div key={p.id} className="card-surface p-5 flex flex-col gap-3" data-testid={`admin-plan-${p.id}`}>
            <div className="flex items-center gap-2"><Crown className="h-4 w-4 text-primary" /><h3 className="font-display text-lg font-bold flex-1">{p.name}</h3>
              {p.custom && <Badge variant="secondary" data-testid={`admin-plan-custom-badge-${p.id}`}>Personalizável</Badge>}
              <Badge variant={p.status === "active" ? "default" : "outline"}>{p.status === "active" ? "Ativo" : "Inativo"}</Badge></div>
            <p className="text-sm text-muted-foreground">{p.description}</p>
            {p.custom ? <p><span className="text-sm text-muted-foreground">a partir de </span><b className="font-display text-2xl">{brl(startingPrice(p))}</b><span className="text-sm text-muted-foreground">/mês · cliente escolhe os módulos</span></p>
              : <p><b className="font-display text-2xl">{brl(p.price)}</b><span className="text-sm text-muted-foreground">/mês · {brl(p.price_yearly)}/ano (-{p.yearly_discount ?? 15}%)</span></p>}
            <ul className="text-sm space-y-1">
              <li>{limitText(p.max_users, "usuário", "usuários")}</li>
              <li>{limitText(p.max_products, "produto", "produtos")}</li>
              <li>{limitText(p.max_orders, "pedido/mês", "pedidos/mês")}</li>
              <li>{limitText(p.max_stores, "loja", "lojas")}</li>
              <li>Suporte: {p.support || "—"}</li>
            </ul>
            {p.custom && <p className="text-xs font-medium text-muted-foreground">Disponíveis para escolha:</p>}
            <div className="flex flex-wrap gap-1">{p.modules.map((m) => <span key={m} className="rounded bg-muted px-1.5 py-0.5 text-[11px]">{MODULE_LABELS[m] || m}</span>)}</div>
            <p className="text-xs text-muted-foreground mt-auto">{p.tenants} cliente(s) ativos neste plano</p>
            <Button variant="outline" onClick={() => setForm({ open: true, plan: p })} data-testid={`admin-edit-plan-${p.id}`}>Editar</Button>
          </div>
        ))}
      </div>
      <PlanFormDialog open={form.open} plan={form.plan} modules={data.modules} onOpenChange={(v) => setForm((x) => ({ ...x, open: v }))} onSaved={load} />
    </div>
  );
}
